import React, { useState } from 'react'
import './LeaderboardSettings.scss'
import NewHeader from '../../../../components/NewHeader'
import TeamSettings from './components/TeamSettings'
import GlobalSettings from './components/GlobalSettings'
import HistoricalLeaderboard from './components/HistoricalLeaderboard'
import HomeIcon from '../../../../assets/icons/home-icon.svg'
import SettingsIcon from '../../../../assets/icons/settings-icon.svg'
import HistoryIcon from '../../../../assets/icons/history-icon.svg'
import ChevronRightIcon from '../../../../assets/icons/chevron-right-icon.svg'
import { useTranslation } from 'react-i18next'

const LeaderboardSettings = ({
  goBack,
  type = 'team',
  selectedCompetition,
  userId
}) => {
  const { t } = useTranslation()
  return (
    <div className="leaderboard-settings-main">
      <div
        className="leaderboard-settings-header-row"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <div className="leaderboard-settings-breadcrumbs">
          <button className="breadcrumb-home" onClick={() => goBack()}>
            <img src={HomeIcon} alt="Home" width="20" height="20" />
          </button>
          <span className="breadcrumb-sep">
            <img src={ChevronRightIcon} alt=">" width="24" height="24" />
          </span>
          {(type === 'global' || type === 'team') && (
            <span className="breadcrumb-settings">
              <img src={SettingsIcon} alt="Settings" width="20" height="20" />
              {t('v4:leaderboard_settings')} (
              {type === 'global' ? 'Global' : 'Team'})
            </span>
          )}
          {type === 'history' && (
            <span className="breadcrumb-settings">
              <img src={HistoryIcon} alt="History" width="20" height="20" />
              {t('v4:history')}
            </span>
          )}
        </div>
        <div className="leaderboard-settings-newheader">
          <NewHeader />
        </div>
      </div>
      <div className="leaderboard-settings-content">
        {type === 'team' && <TeamSettings goBack={goBack} />}
        {type === 'global' && <GlobalSettings />}
        {type === 'history' && (
          <HistoricalLeaderboard
            selectedCompetition={selectedCompetition}
            userId={userId}
          />
        )}
      </div>
    </div>
  )
}

export default LeaderboardSettings
